// cross browsers addRule method
import{raf}from'./raf.js';export function removeCSSRule(sheet,index){// return raf(function() {
'deleteRule'in sheet?sheet.deleteRule(index):sheet.removeRule(index);// });
}